import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  return (
    <div className="services-page">
      {/* Hero Banner */}
      <section className="services-hero">
        <div className="hero-content">
          <h1>Our Professional Construction Services</h1>
          <p className="subtitle">Quality craftsmanship for every project since 2010</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-grid-section">
        <div className="container">
          <h2>Specialized Construction Solutions</h2>
          <p className="section-intro">
            We deliver exceptional results through skilled craftsmanship and attention to detail. 
            Explore our comprehensive range of professional construction services.
          </p>

          <div className="services-grid">
            {/* Service 1 */}
            <div className="service-card">
              <div className="service-icon">🪚</div>
              <h3>Wood & Timber Work</h3>
              <ul className="service-features">
                <li>Custom woodworking & carpentry</li>
                <li>Structural timber framing</li>
                <li>Decorative wood features</li>
                <li>Precision joinery</li>
                <li>Restoration & repair</li>
              </ul>
            </div>

            {/* Service 2 */}
            <div className="service-card">
              <div className="service-icon">🏠</div>
              <h3>Roof Conversions & Extensions</h3>
              <ul className="service-features">
                <li>Loft conversions</li>
                <li>Dormer extensions</li>
                <li>Roof line modifications</li>
                <li>Structural assessments</li>
                <li>Planning permission assistance</li>
              </ul>
            </div>

            {/* Service 3 */}
            <div className="service-card">
              <div className="service-icon">🪵</div>
              <h3>Wood Flooring & Cabinets</h3>
              <ul className="service-features">
                <li>Hardwood floor installation</li>
                <li>Engineered wood flooring</li>
                <li>Custom cabinetry</li>
                <li>Built-in storage solutions</li>
                <li>Refinishing & restoration</li>
              </ul>
            </div>

            {/* Service 4 */}
            <div className="service-card">
              <div className="service-icon">🚪</div>
              <h3>Doors & Windows</h3>
              <ul className="service-features">
                <li>Energy-efficient double glazing</li>
                <li>Custom door fabrication</li>
                <li>French & patio doors</li>
                <li>Window replacement</li>
                <li>Weatherproofing solutions</li>
              </ul>
            </div>

            {/* Service 5 */}
            <div className="service-card">
              <div className="service-icon">🍳</div>
              <h3>Professional Kitchen Installation</h3>
              <ul className="service-features">
                <li>Custom kitchen design</li>
                <li>High-end appliance fitting</li>
                <li>Countertop fabrication</li>
                <li>Plumbing & electrical integration</li>
                <li>Complete remodeling</li>
              </ul>
            </div>

            {/* Service 6 - Additional */}
            <div className="service-card">
              <div className="service-icon">📞</div>
              <h3>Custom Solutions</h3>
              <p>Have a unique project? We specialize in custom construction solutions tailored to your specific needs.</p>
              <Link to="/contact" className="consultation-button">Request Consultation</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="work-process-section">
        <div className="container">
          <h2>Our Work Process</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Initial Consultation</h3>
                <p>We discuss your vision, requirements, and budget to understand your project scope.</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Detailed Planning</h3>
                <p>Our team creates precise plans and renderings to visualize the final result.</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Material Selection</h3>
                <p>We guide you in choosing the best materials for durability, aesthetics, and value.</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Professional Execution</h3>
                <p>Our skilled craftsmen bring the project to life with meticulous attention to detail.</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">5</div>
              <div className="step-content">
                <h3>Quality Assurance</h3>
                <p>We conduct thorough inspections to ensure complete satisfaction before project completion.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta">
        <div className="container">
          <h2>Ready to Transform Your Space?</h2>
          <p>Contact us today for a free estimate and professional advice on your construction project.</p>
          <div className="cta-buttons">
          <Link to="/contact" className="primary-cta">Get a Free Quote</Link>
            <button className="secondary-cta">Call Now: 07853497378</button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;